import { createPopper } from '@popperjs/core';

const popperInstances = [];

const mapSpots = document.querySelectorAll('.js-map-spot');

mapSpots.forEach((button) => {

    const tooltipBoundary = document.querySelector('.js-tooltip-boundary');
    const tooltipID = button.getAttribute('aria-describedby');
    const tooltip = document.getElementById(tooltipID);

    const popperInstance = createPopper(button, tooltip, {
        placement: 'top',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 12],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    boundary: tooltipBoundary,
                    padding: 15,
                },
            },
        ],
    });

    popperInstances.push(popperInstance);

    const showEvents = ['mouseenter', 'focus'];

    showEvents.forEach((event) => {

        // eslint-disable-next-line
        button.addEventListener(event, () => showTooltip(popperInstance));

    });

    // eslint-disable-next-line
    addPulse(popperInstance);

});

function showTooltip(popperInstance) {

    const tooltip = popperInstance.state.elements.popper;

    // Hide all tooltips
    // eslint-disable-next-line
    hideAllTooltips();

    // Make the tooltip visible
    tooltip.setAttribute('data-show', '');

    // Enable the event listeners
    // eslint-disable-next-line
    addHideListeners(popperInstance);

    popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [
            ...options.modifiers,
            { name: 'eventListeners', enabled: true },
        ],
    }));

    // Update its position
    popperInstance.update();

}

function hideTooltip(popperInstance) {

    const tooltip = popperInstance.state.elements.popper;

    // Hide the tooltip
    tooltip.removeAttribute('data-show');

    // Disable the event listeners
    popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [
            ...options.modifiers,
            { name: 'eventListeners', enabled: false },
        ],
    }));

}

function addHideListeners(popperInstance) {

    const tooltip = popperInstance.state.elements.popper;
    const closeButton = tooltip.querySelector('.js-tooltip-close');

    const onDocumentClick = (event) => {

        // eslint-disable-next-line
        if (!isCursorInsideTooltip(event, popperInstance)) {

            // eslint-disable-next-line
            removeHideListeners();
            hideTooltip(popperInstance);

        }

    };

    // eslint-disable-next-line
    const onCloseClick = (event) => {

        // eslint-disable-next-line
        removeHideListeners();
        hideTooltip(popperInstance);

    };

    function removeHideListeners() {

        document.removeEventListener('click', onDocumentClick);
        closeButton.removeEventListener('click', onCloseClick);

    }

    document.addEventListener('click', onDocumentClick);
    closeButton.addEventListener('click', onCloseClick);

}

function isCursorInsideTooltip(event, popperInstance) {

    const tooltip = popperInstance.state.elements.popper;
    const mapSpot = popperInstance.state.elements.reference;

    if (event.target === tooltip || tooltip.contains(event.target)) {

        return true;

    }

    if (event.target === mapSpot || mapSpot.contains(event.target)) {

        return true;

    }

    return false;

}

function hideAllTooltips() {

    popperInstances.forEach((popperInstance) => {

        hideTooltip(popperInstance);
        // eslint-disable-next-line
        removePulse(popperInstance);

    });

}

function addPulse(popperInstance) {

    const mapSpot = popperInstance.state.elements.reference;

    mapSpot.classList.add('pulse');

}

function removePulse(popperInstance) {

    const mapSpot = popperInstance.state.elements.reference;

    mapSpot.classList.remove('pulse');

}
